<template>
  <div class="article-view">
    <div class="search-pg">
      <Search />
    </div>
    <div class="container">
      <div class="breadcrumb-wrap">
        <v-breadcrumbs :items="breadcrumbs" />
      </div>
      <div class="position">
        <div
          v-if="
                article.parent && !article.parent.hide_tab && tabs && tabs.children
              "
          class="tabs-main"
        >
          <v-tabs centered>
            <v-tab
              v-for="tab in tabs.children"
              :key="tab.id"
              :slug="tab.slug"
              :class="{ 'v-tab--active': tab.slug === article.slug }"
              :to="{ params: { slug: tab.slug } }"
            >
              {{ tab.transTitle }}
            </v-tab>
          </v-tabs>
        </div>
        <div class="bg-white p-20">
          <div v-if="article">
            <div v-if="article.npa_view_type && article.npa_view_type.id === 3" class="npa-content-view">
              <h1 class="title-pg">{{ article.transTitle }}</h1>

              <div class="search-body mt-5">
                <div class="search-result">
                  <div class="search-result-body">
                    <!-- Управление видом (список/плитка) -->
                    <div class="d-flex justify-end mb-4">
                      <a
                        href="#"
                        class="btn-column-list"
                        :aria-label="showBlock ? $t('Показать списком') : $t('Показать плиткой')"
                        @click.prevent="showBlock = !showBlock"
                      >
                        <v-icon x-large aria-hidden="true">{{ showBlock ? 'mdi-view-list' : 'mdi-view-module' }}</v-icon>
                      </a>
                    </div>

                    <!-- Таблица (Desktop) -->
                    <mq-layout mq="laptop">
                      <div class="type-column">
                        <v-simple-table v-if="!showBlock">
                          <thead>
                          <tr>
                            <th><a href="#" :aria-label="$t('Сортировать') + ': ' + $t('Вид проекта')" @click.prevent="sortData('view')">{{ $t('Вид проекта') }}</a></th>
                            <th><a href="#" :aria-label="$t('Сортировать') + ': ' + $t('Наименование')" @click.prevent="sortData('name')">{{ $t('Наименование') }}</a></th>
                            <th>{{ $t('Комментарии') }}</th>
                            <th>{{ $t('Разработчик') }}</th>
                            <th>{{ $t('Статус') }}</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="item in result" :key="item.id">
                            <td>{{ item.view.transName }}</td>
                            <td>
                              <router-link :to="$i18nRoute({ name: 'view-npa', params: { id: item.id } })">
                                {{ item.transName }}
                              </router-link>
                            </td>
                            <td>
                              <div class="analytics">
                                <span class="views"><i class="pro-icon-eye" aria-hidden="true"></i><span class="sr-only">{{ $t('Просмотры') }}: </span> {{ item.view_number }}</span>
                                <span class="comments"><i class="pro-icon-chat" aria-hidden="true"></i><span class="sr-only">{{ $t('Комментарии') }}: </span> {{ commentsCnt[item.id] ? commentsCnt[item.id].cntComments : 0 }}</span>
                              </div>
                            </td>
                            <td>{{ item.developer.transName }}</td>
                            <td>{{ item.status.transName }}</td>
                          </tr>
                          </tbody>
                        </v-simple-table>

                        <!-- Плитка (Desktop) -->
                        <v-row v-else>
                          <v-col cols="12" md="4" v-for="item in result" :key="item.id">
                            <div class="project-card border p-3 mb-3">
                              <div class="project-type grey--text small">{{ item.view.transName }}</div>
                              <div class="npa-title font-weight-bold">
                                <router-link :to="$i18nRoute({ name: 'view-npa', params: { id: item.id } })">
                                  {{ item.transName }}
                                </router-link>
                              </div>
                              <div class="date-period mt-2 small">
                                {{ item.status.transName }}
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </mq-layout>

                    <!-- Mobile View -->
                    <mq-layout mq="mobile">
                      <v-row>
                        <v-col cols="12" v-for="item in result" :key="item.id" class="border-bottom py-3">
                          <router-link :to="$i18nRoute({ name: 'view-npa', params: { id: item.id } })">
                            {{ item.transName }}
                          </router-link>
                          <div class="small grey--text">{{ item.status.transName }}</div>
                        </v-col>
                      </v-row>
                    </mq-layout>
                  </div>

                  <div class="search-result-footer mt-4">
                    <p>{{ $t('Общее количество НПА') }}: {{ paginationData.totalCount || 0 }}</p>
                    <v-pagination
                      v-model="page"
                      :length="paginationData.pageCount || 1"
                      :aria-label="$t('Страницы результатов поиска')"
                      total-visible="7"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <h1 v-if="!article.hide_title" class="title-pg">
                {{ article.transTitle }}
              </h1>
              <div
                v-if="!article.hide_content"
                class="content"
                v-html="article.transContent"
              ></div>

              <div class="share-soc">
                <div class="share-icons">
                  <Social
                    :title="article.transTitle"
                    :quote="article.transTitle"
                    :url="currentUrl"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CMS from '@/model/cms'
import Search from '@/components/Search'
import {Trans} from "@/plugins/Translation"
import Social from "@/components/Social"
import { mapMutations } from 'vuex'
import SearchModel from '@/model/search'

export default {
  components: {
    Search,
    Social
  },
  data: () => ({
    article: null,
    breadcrumbs: [],
    tabs: null,
    title: '',
    description: '',
    keywords: '',
    currentUrl: '',

    result: [],
    page: 1,
    search: {},
    paginationData: {},
    commentsCnt: {},
    answersCnt: {},
    showBlock: false,
    orderBy: 'publishDate',
    orderDir: 'desc'
  }),
  metaInfo () {
    return {
      title: this.title,
      meta: [{
        vmid: 'description',
        name: 'description',
        content: this.description,
      }, {
        vmid: 'keywords',
        name: 'keywords',
        content: this.keywords,
      }]
    }
  },
  watch: {
    '$route.params.slug': 'fetchData',
    page (val) {
      if (this.article && this.article.npa_view_type && this.article.npa_view_type.id === 3) {
        this.searchNPA(7, '', false)
      }
    }
  },
  created() {
    this.fetchData()
    this.currentUrl = window.location.href
    this.scrollToTop()
  },
  methods: {
    ...mapMutations(['setLoading']),
    fetchData() {
      this.setLoading(true)
      CMS.loadPageBySlug(this.$route.params.slug)
        .then((response) => {
          this.article = response.data

          this.breadcrumbs = [
            {
              text: this.$i18n.t('Главная'),
              disabled: false,
              href: Trans.currentLocaleUrl + '/'
            }
          ]

          if (this.article) {
            this.title = this.article.transTitle
            this.description = this.article.transDescription
            this.keywords = this.article.transKeywords

            if (this.article.parent) {
              this.breadcrumbs.push({
                text: this.article.parent.transTitle,
                disabled: false,
                href: Trans.currentLocaleUrl + '/blog/' + this.article.parent.slug
              })

              if (this.article.parent.hide_tab === false) {
                CMS.loadBlogBySlug(this.article.parent.slug).then(res => { this.tabs = res.data })
              }
            }

            this.breadcrumbs.push({ text: this.article.transTitle, disabled: true })

            if (this.article.npa_view_type && this.article.npa_view_type.id === 3) {
              this.clearSort()
              this.searchNPA(7, '', true)
            }
          }
          this.setLoading(false)
        })
        .catch(() => { this.setLoading(false) })
    },
    searchNPA (initiatorId, name, reset = true) {
      if (reset) this.page = 1

      this.search = {
        initiator: initiatorId,
        page: this.page,
        orderBy: this.orderBy,
        orderDir: this.orderDir,
      }

      this.setLoading(true)
      SearchModel.search(this.search)
        .then((response) => {
          this.result = response.data.items
          this.paginationData = response.data.paginationData
          this.commentsCnt = response.data.commentsCnt
          this.answersCnt = response.data.answersCnt
          this.setLoading(false)
        })
        .catch(() => { this.setLoading(false) })
    },

    sortData(sortKey) {
      if (this.orderBy !== sortKey) {
        this.orderDir = 'desc'
      } else {
        this.orderDir = this.orderDir === 'desc' ? 'asc' : 'desc'
      }
      this.orderBy = sortKey
      this.searchNPA(7, '', true)
    },

    clearSort () {
      this.orderBy = 'publishDate'
      this.orderDir = 'desc'
    },

    scrollToTop() {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style lang="scss">
.article-view {

  .tabs-main {
    margin-bottom: 0;

    .v-tab {
      color: #ffffff !important;
      text-decoration: underline !important;
      padding: 10px  !important;
      letter-spacing: normal!important;

      &.v-tab--active {
        background-color: #ffffff !important;
        color: #000000 !important;
        text-decoration: none !important;
        font-weight: 500;
        position: relative;
        overflow: visible !important;
        letter-spacing: normal!important;
      }

      .v-btn__content {
        color: inherit !important;
      }
    }
  }
}
</style>
